import { render, staticRenderFns } from "./ShowComments.vue?vue&type=template&id=79c7ef02"
import script from "./ShowComments.vue?vue&type=script&lang=js"
export * from "./ShowComments.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports